import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/jarl/Documents/Projects/civitas/kenobi/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import { Dialog, Button } from 'kenobi-ui';
import Component from '@reach/component-component';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "dialog"
    }}>{`Dialog`}</h1>
    <h3 {...{
      "id": "accessible-dialogmodal"
    }}>{`Accessible Dialog/Modal.`}</h3>
    <h2 {...{
      "id": "implementation-details"
    }}>{`Implementation details`}</h2>
    <h3 {...{
      "id": "by-default-aria-label-will-be-set-as-the-title-prop"
    }}>{`By default aria-label will be set as the `}<inlineCode parentName="h3">{`title`}</inlineCode>{` prop.`}</h3>
    <h3 {...{
      "id": "you-can-control-this-by-passing-the-arialabel-prop-if-none-have-been-passed-aria-label-will-contain-nothing"
    }}>{`You can control this by passing the `}<inlineCode parentName="h3">{`ariaLabel`}</inlineCode>{` prop. If none have been passed, aria-label will contain nothing.`}</h3>
    <h3 {...{
      "id": "please-always-use-one-or-the-other"
    }}>{`Please always use one or the other.`}</h3>
    <h3 {...{
      "id": "the-close-icon-contains-a-visually-hidden-element-this-provides-a-text-version-of-the-icon-to-screen-readers"
    }}>{`The close icon contains a `}<inlineCode parentName="h3">{`Visually Hidden`}</inlineCode>{` element. This provides a text version of the icon to screen readers.`}</h3>
    <h3 {...{
      "id": "all-scrolling-outside-the-dialog-is-disabled-focus-is-locked-inside-the-dialog-window-focus-will-also-be-returned-to-the-trigger-element"
    }}>{`All scrolling outside the Dialog is disabled. Focus is locked inside the Dialog window. Focus will also be returned to the Trigger element.`}</h3>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <Playground __position={0} __code={'<Component initialState={{ isOpen: false }}>\n  {({ setState, state }) => (\n    <div>\n      <Button onClick={() => setState({ isOpen: true })}>Open Dialog</Button>\n      <Dialog\n        isOpen={state.isOpen}\n        title=\"Dialog title\"\n        onRequestClose={() => setState({ isOpen: false })}\n      >\n        <div style={{ height: \'400px\' }}>Dialog content</div>\n      </Dialog>\n    </div>\n  )}\n</Component>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Dialog,
      Button,
      Component
    }} mdxType="Playground">
  <Component initialState={{
        isOpen: false
      }} mdxType="Component">
    {({
          setState,
          state
        }) => <div>
        <Button onClick={() => setState({
            isOpen: true
          })} mdxType="Button">Open Dialog</Button>
        <Dialog isOpen={state.isOpen} title="Dialog title" onRequestClose={() => setState({
            isOpen: false
          })} mdxType="Dialog">
          <div style={{
              height: '400px'
            }}>Dialog content</div>
        </Dialog>
      </div>}
  </Component>
    </Playground>
    <h2 {...{
      "id": "focusing"
    }}>{`Focusing`}</h2>
    <h3 {...{
      "id": "by-default-the-close-icon-is-always-focused-on-opening"
    }}>{`By default the close icon is always focused on opening.`}</h3>
    <h3 {...{
      "id": "if-you-want-another-element-to-be-focused-on-opening-you-can-specify-data-autofocus-on-the-element"
    }}>{`If you want another element to be focused on opening, you can specify `}<inlineCode parentName="h3">{`data-autofocus`}</inlineCode>{` on the element.`}</h3>
    <Playground __position={1} __code={'<Component initialState={{ isOpen: false }}>\n  {({ setState, state }) => (\n    <div>\n      <Button onClick={() => setState({ isOpen: true })}>Open Dialog</Button>\n      <Dialog\n        isOpen={state.isOpen}\n        title=\"Dialog title\"\n        onRequestClose={() => setState({ isOpen: false })}\n      >\n        <div style={{ height: \'1200px\' }}>\n          <Button data-autofocus>Dialog content</Button>\n        </div>\n      </Dialog>\n    </div>\n  )}\n</Component>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Dialog,
      Button,
      Component
    }} mdxType="Playground">
  <Component initialState={{
        isOpen: false
      }} mdxType="Component">
    {({
          setState,
          state
        }) => <div>
        <Button onClick={() => setState({
            isOpen: true
          })} mdxType="Button">Open Dialog</Button>
        <Dialog isOpen={state.isOpen} title="Dialog title" onRequestClose={() => setState({
            isOpen: false
          })} mdxType="Dialog">
          <div style={{
              height: '1200px'
            }}>
            <Button data-autofocus mdxType="Button">Dialog content</Button>
          </div>
        </Dialog>
      </div>}
  </Component>
    </Playground>
    <h2 {...{
      "id": "internal-scrolling"
    }}>{`Internal scrolling`}</h2>
    <Playground __position={2} __code={'<Component initialState={{ isOpen: false }}>\n  {({ setState, state }) => (\n    <div>\n      <Button onClick={() => setState({ isOpen: true })}>Open Dialog</Button>\n      <Dialog\n        isOpen={state.isOpen}\n        title=\"Dialog title\"\n        onRequestClose={() => setState({ isOpen: false })}\n      >\n        <div style={{ height: \'1200px\' }}>Dialog content</div>\n      </Dialog>\n    </div>\n  )}\n</Component>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Dialog,
      Button,
      Component
    }} mdxType="Playground">
  <Component initialState={{
        isOpen: false
      }} mdxType="Component">
    {({
          setState,
          state
        }) => <div>
        <Button onClick={() => setState({
            isOpen: true
          })} mdxType="Button">Open Dialog</Button>
        <Dialog isOpen={state.isOpen} title="Dialog title" onRequestClose={() => setState({
            isOpen: false
          })} mdxType="Dialog">
          <div style={{
              height: '1200px'
            }}>Dialog content</div>
        </Dialog>
      </div>}
  </Component>
    </Playground>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Props of={Dialog} mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      